<template>
  <div v-if="Object.keys(types).length" style="width: 50%">
    <!-- Use a ref instead of id -->
    <div class="pie-container">
      <h3>Terminal Type</h3>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        "
      >
        <div class="pie-wrapper">
          <div ref="pieChart" class="ct-pie"></div>
        </div>

        <div class="custom-legend">
          <div
            style="
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 8px;
            "
            v-for="(label, index) in pieChartData.labels"
            :key="index"
          >
            <span
              class="circle"
              style="
                display: block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
              "
              :style="{
                backgroundColor:
                  pieChartData.datasets[0].backgroundColor[index],
              }"
            ></span>
            <span
              class="legend-text"
              style="display: flex; align-items: center; gap: 8px"
            >
              {{ label }}
              <span style="color: #615e83; font-size: 14px"
                >{{ pieChartData.datasets[0].data[index] }}%</span
              >
              <span style="color: #23242f; font-size: 14px"
                >({{ pieChartData.counts[index] }})</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chartist from "chartist";
import axios from "../store/axios";
import "chartist/dist/chartist.min.css";

export default {
  name: "TerminalPieChart",
  data() {
    return {
      types: {},
    };
  },

  computed: {
    pieChartData() {
      return {
        labels: ["T3 POS", "MPOS", "CARD READER"],
        counts: [
          Number(this.types.T3POS.count || 0),
          Number(this.types.MPOS.count || 0),
          Number(this.types.CARD_READER.count || 0),
        ],
        datasets: [
          {
            backgroundColor: ["#75D7F0", "#1687A4", "#3CAFCD"],
            data: [
              Number(this.types.T3POS.percent || 0),
              Number(this.types.MPOS.percent || 0),
              Number(this.types.CARD_READER.percent || 0),
            ],
          },
        ],
      };
    },
  },

  methods: {
    async getTerminalData() {
      console.log("getting terminal data");
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/terminal-summary`,
        );

        console.log("terminals pie chart", res);

        const { types } = res.data.data;
        console.log("pie chart", types);
        this.types = types;
        console.log("types", this.types);
        // this.buildChart();

        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    buildChart() {
      console.log("building chart", this.types);
      //   const labels = Object.keys(this.types);
      const labels = ["T3 POS", "MPOS", "CARD READER"];
      //   const series = Object.values(this.types).map((t) => t.count);
      const series = [
        Number(this.types.T3POS.count),
        Number(this.types.MPOS.count),
        Number(this.types.CARD_READER.count),
      ];

      new Chartist.Pie(
        this.$refs.pieChart,
        {
          labels,
          series,
        },
        {
          showLabel: true,
        },
      );
    },
  },

  async mounted() {
    await this.getTerminalData();
    this.buildChart();
  },
};
</script>

<style>
/* Chartist container size */
div[ref="pieChart"]
/* .ct-chart {
  height: 900px;
  width: 900px;
  margin: 0 auto;
} */

/* Custom slice colors */
.ct-series-a .ct-slice-pie {
  fill: #75d7f0 !important;
}
.ct-series-b .ct-slice-pie {
  fill: #1687a4 !important;
}
.ct-series-c .ct-slice-pie {
  fill: #3cafcd !important;
}

/* Labels */
.ct-label {
  fill: white;
  font-size: 8px;
  font-weight: bold;
}

.pie-container {
  background: white;
  padding: 16px;
  border-radius: 8px;
  height: 100%;
  width: 100%;
}

.pie-container h3 {
  margin: 0;
  color: black;
  width: fit-content;
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 20px;
}

.pie-wrapper {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: 400px; /* chart container height */
  width: 400px; /* chart container width */
}

.ct-pie {
  height: 100%;
  width: 100%;
}
</style>
